<template>
  <v-dialog v-model="dialogVisible" 
    persistent
    max-width="360px" 
  >
    <template #activator="{ on }">
      <v-btn 
        x-small color="grey lighten-4" 
        v-bind="$attrs" v-on="on"
        :disabled="!user.active"
      >
        Send Reminder
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="d-flex justify-center">Please Confirm</v-card-title>

      <v-divider />

      <v-card-text class="pt-2">
        This will send an account reminder message to <strong>{{ user.email }}</strong>. From there, they can either login, or recover their password.
      </v-card-text>

      <v-divider class="mt-3"/>

      <v-card-actions class="justify-center py-4">
        <v-btn @click="close" color="grey lighten-4">Cancel</v-btn>
        <v-btn color="primary" @click="remindClick">Send</v-btn>
      </v-card-actions>
    </v-card>

    <ErrorOverlay
      title="Error Updating User"
      v-model="error_dialog"
      :loading="loading"
    >
      {{ error_message }}
    </ErrorOverlay>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import { required } from '@/lib/validations'
import ErrorOverlayMixin from '@/lib/mixins/ErrorOverlay'

export default {
  name: 'ReminderDialog',

  mixins: [ ErrorOverlayMixin ],

  props: ['user'],

  data() {
    return {
      dialogVisible: false,

      // validation rules
      required,
    }
  },

  methods: {
    ...mapActions('users', ['sendReminder']),

    close() {
      this.dialogVisible = false
      this.$emit('close')
    },

    async remindClick() {
      const { user_id } = this.user

      this.loading = true
      const result = await this.sendReminder({ user_id })
      this.loading=false

      if(result.ok) {
        this.close()
      } else {
        this.error_dialog = true
        this.error_message = result.error
      }
    }, 
  },
}
</script>

<style scoped>
  .v-dialog__content {
    position:  absolute;
  }
</style>